import type { Dispatch, SetStateAction } from "react";
import type { LabSettings, MotionProfile, RendererLoad } from "../types";

export function ControlDeck({
  settings,
  setSettings,
}: {
  settings: LabSettings;
  setSettings: Dispatch<SetStateAction<LabSettings>>;
}) {
  const patch = (next: Partial<LabSettings>) =>
    setSettings((current) => ({ ...current, ...next }));

  return (
    <section className="control-deck" aria-label="Lab controls">
      <div className="control-group">
        <span className="control-label">Motion profile</span>
        <div className="segmented">
          {(["system", "full", "reduced"] as MotionProfile[]).map((profile) => (
            <button
              key={profile}
              aria-pressed={settings.profile === profile}
              onClick={() => patch({ profile })}
            >
              {profile}
            </button>
          ))}
        </div>
      </div>
      <label className="range-control">
        <span><span className="control-label">Intensity</span><output>{Math.round(settings.intensity * 100)}%</output></span>
        <input
          aria-label="Motion intensity"
          type="range"
          min="0"
          max="1"
          step="0.05"
          value={settings.intensity}
          onChange={(event) => patch({ intensity: Number(event.target.value) })}
        />
      </label>
      <div className="control-group">
        <span className="control-label">Renderer load</span>
        <div className="segmented">
          {(["light", "medium", "stress"] as RendererLoad[]).map((load) => (
            <button
              key={load}
              aria-pressed={settings.load === load}
              onClick={() => patch({ load })}
            >
              {load}
            </button>
          ))}
        </div>
      </div>
      <button
        className="hud-toggle"
        aria-pressed={settings.hud}
        onClick={() => patch({ hud: !settings.hud })}
      >
        HUD {settings.hud ? "on" : "off"}
      </button>
    </section>
  );
}
